import AdminSidebarItem from "./AdminSidebarItem";

const AdminSidebarSection = ({
  title,
  items,
  collapsed = false,
  onNavigate,
}) => {
  if (!items?.length) {
    return null;
  }

  return (
    <section className="admin-sidebar__section">
      <div className="admin-sidebar__section-title">{title}</div>
      <div className="admin-sidebar__section-items">
        {items.map((item) => (
          <AdminSidebarItem
            key={item.to}
            item={item}
            collapsed={collapsed}
            onNavigate={onNavigate}
          />
        ))}
      </div>
    </section>
  );
};

export default AdminSidebarSection;
